export const SHOPIFY_API_LIBRARY_VERSION = '12.2.0';
